var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MiniIcon--small MiniIcon QuestionMarkMiniIcon",
    focusable: "false",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47461 7.35C5.47461 3.75 8.62461 1.5 11.9996 1.5C15.0746 1.5 18.5246 3.6 18.5246 6.975C18.5246 9.15 17.4746 10.65 15.7496 11.85C15.1496 12.3 14.4746 12.825 13.9496 13.35C13.4246 14.025 13.0496 14.85 13.0496 15.9H10.1246C10.0496 15.525 9.97461 15 9.97461 14.7C9.97461 10.425 15.1496 10.05 15.1496 7.05C15.1496 5.4 13.4996 4.425 12.0746 4.425C10.1996 4.425 8.77461 5.925 8.77461 7.8C8.77461 8.1 8.77461 8.325 8.84961 8.55L5.54961 8.4C5.47461 8.1 5.47461 7.725 5.47461 7.35ZM11.6246 22.5C12.7496 22.5 13.7246 21.6 13.7246 20.475C13.7246 19.35 12.7496 18.375 11.6246 18.375C10.4996 18.375 9.59961 19.275 9.59961 20.475C9.59961 21.675 10.4996 22.5 11.6246 22.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.599f9cec.svg";
export { ForwardRef as ReactComponent };